import BaseService from "./BaseService";

export default class RecommendSearchingListService extends BaseService{
    async getRecommendSearchingList(data){
        const url = this.API.recommendSearching.getRecommendSearchingList;
        let result = await this.get(url, data);
        return result;
    }

    async searchKeyWords(data){
        const url = this.API.recommendSearching.searchKeyWord+data;
        let result = await this.get(url);
        return result;
    }

    async searchProductAPart(data){
       let url = this.API.recommendSearching.searchProductAPart;
       let result = await this.get(url, data);
       return result;
    }

    async searchProductAll(data){
        let url = this.API.recommendSearching.searchProductAll+data;
        let result = await this.get(url, {});
        return result;
    }

}



// WEBPACK FOOTER //
// ./src/service/services/RecommendSearchingListService.js